import type { PageFilterKeys } from '@/pages/opinion/components/FilterCommon/types';
import feedsPlayFeedback from '@op/operationLog/pages/feedsPlayFeedback';
import feedsPrivateDiscord from '@op/operationLog/pages/feedsPrivateDiscord';
import feedsChatting from '@op/operationLog/pages/feedsChatting';
import feedsSecurity from '@op/operationLog/pages/feedsSecurity';
import moment from 'moment';

export const privateSourceGameIds = [
  'e11000000297',
  'ec41360495e0a6b2eb0809ded33746044',
  'ebbb05959d61b945e99b9c013a9028a69',
];

// 这里的isNightingale参数代表所有的带有private source tab的页面

export const specialChannelMap: {
  [key: string]: {
    tabText: string;
    tabValue: string;
    edition_unified_id: string;
    entity_name: string;
    pageName?: PageFilterKeys;
    specialParams?: any;
    filterDefaultValue?: any;
    filterDefaultConfig?: any;
    buriedPointInfo: any;
    hasEndElement?: boolean;
    showAigcBtn?: boolean;
  };
} = {
  // 2024 05  23 下掉了hok的特殊tab
  // u10000000066: {
  //   tabText: 'Chatting',
  //   tabValue: 'chatting',
  //   edition_unified_id: 'u10000000066',
  //   entity_name: 'Honor of Kings',
  //   buriedPointInfo: feedsChatting,
  //   pageName: 'Feeds_Chatting',
  //   hasEndElement: false,
  //   specialParams: {
  //     channel: ['hok_cbt_chatting'],
  //     channel_type: 'social',
  //   },
  // },
  u10000000022: {
    tabText: 'Chatting',
    tabValue: 'chatting',
    edition_unified_id: 'u10000000022',
    entity_name: 'Arena Breakout',
    buriedPointInfo: feedsChatting,
    pageName: 'Feeds_Chatting',
    specialParams: {
      channel: ['uamo_chatting'],
      channel_type: 'social',
    },
  },
  // u6d721eb69ef7de198bb84be26be6d40b: {
  //   tabText: 'Chatting',
  //   tabValue: 'chatting',
  //   edition_unified_id: 'u6d721eb69ef7de198bb84be26be6d40b',
  //   entity_name: 'Tower of Fantasy',
  //   buriedPointInfo: feedsChatting,
  //   pageName: 'Feeds_Chatting',
  //   hasEndElement: false,
  //   specialParams: {
  //     channel: ['tof_chatting'],
  //     channel_type: 'social',
  //   },
  // },
  ebaf4c80cdf9f22c672b348e8b19d57c8: {
    tabText: 'Security Channel',
    tabValue: 'chatting',
    edition_unified_id: 'ebaf4c80cdf9f22c672b348e8b19d57c8',
    entity_name: 'The Texas Chain Saw Massacre',
    buriedPointInfo: feedsSecurity,
    pageName: 'Feeds_Chatting',
    hasEndElement: false,
    filterDefaultValue: {
      start_time: moment().subtract(89, 'day').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    specialParams: {
      channel: [],
      channel_type: 'security',
    },
  },
  e11000000297: {
    tabText: 'Private Source',
    tabValue: 'discordPrivate',
    edition_unified_id: 'e11000000297',
    entity_name: 'Nightingale',
    pageName: 'Feeds_Private_Source',
    hasEndElement: true,
    filterDefaultValue: {
      start_time: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    filterDefaultConfig: {
      monitor: {
        isDiscordPrivate: true,
        isNightingale: true,
        onlyAccount: true,
        returnAllValue: true,
      },
    },
    buriedPointInfo: feedsPrivateDiscord,
  },
  ebbb05959d61b945e99b9c013a9028a69: {
    tabText: 'Private Source',
    tabValue: 'discordPrivate',
    edition_unified_id: 'ebbb05959d61b945e99b9c013a9028a69',
    entity_name: 'Last Epoch',
    pageName: 'Feeds_Private_Source',
    hasEndElement: true,
    showAigcBtn: true,
    filterDefaultValue: {
      start_time: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    filterDefaultConfig: {
      monitor: {
        isDiscordPrivate: true,
        isNightingale: true,
        onlyAccount: true,
        returnAllValue: true,
      },
    },
    buriedPointInfo: feedsPrivateDiscord,
  },
  ec41360495e0a6b2eb0809ded33746044: {
    tabText: 'Private Source',
    tabValue: 'discordPrivate',
    edition_unified_id: 'ec41360495e0a6b2eb0809ded33746044',
    entity_name: 'V Rising',
    pageName: 'Feeds_Private_Source',
    hasEndElement: true,
    showAigcBtn: true,
    filterDefaultValue: {
      start_time: moment().subtract(3, 'month').format('YYYY-MM-DD'),
      end_time: moment().format('YYYY-MM-DD'),
    },
    filterDefaultConfig: {
      monitor: {
        isDiscordPrivate: true,
        isNightingale: true,
        onlyAccount: true,
        returnAllValue: true,
      },
    },
    buriedPointInfo: feedsPrivateDiscord,
  },
  u10000000028: {
    tabText: 'Player Feedback',
    tabValue: 'playerFeedback',
    edition_unified_id: 'u10000000028',
    entity_name: 'Pokémon UNITE',
    pageName: 'Feeds_Player_Feedback',
    hasEndElement: false,
    buriedPointInfo: feedsPlayFeedback,
    specialParams: {
      channel: ['nishikiお問い合わせ詳細データ'],
      channel_type: 'social',
    },
  },
};

export const specialParamsMap: {
  [key: string]: { [key: string]: any };
} = {
  // uef4312b08dde07820374dd57086ea2fb: {
  //   page_source: 'nikke',
  // },
};

export const getSearchText = ({
  isSearch = false,
  text = 'Search for reviews by keywords or phrase',
  width = 1600,
}) => {
  if (width <= 1590) {
    return isSearch ? 'Pressing ‘Enter’ will return' : text;
  }
  return isSearch ? 'Pressing ‘Enter’ will return to the original list.' : text;
};
